import "client-only";
import useSWR from "swr";
import { fetcher } from "src/utils/fetcher";

/** GET /api/v1/orders/code?code=&warehouse= — tìm đơn theo mã vận chuyển hoặc mã đơn */
function useOrderByCodeLookup(code, warehouse) {
  return useSWR(
    code && warehouse
      ? {
          path: "/api/v1/orders/code",
          method: "GET",
          params: { code, warehouse },
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: false,
    },
  );
}

export default useOrderByCodeLookup;
